module.exports = __webpack_public_path__ + "img/step-2.add41939.jpg";